import { render, staticRenderFns } from "./DrawingRedo.vue?vue&type=template&id=d8b35d1e"
import script from "./DrawingRedo.vue?vue&type=script&lang=js"
export * from "./DrawingRedo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports